var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPaymentMethod = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_peyment_method",
    d: "M232.815,800.124H224.7v-2.286a1.137,1.137,0,0,1,1.125-1.143h6.75v1.143A10.458,10.458,0,0,0,232.815,800.124Zm9.842,2.286h.046v5.714h0a1.134,1.134,0,0,1-1.125,1.143h-15.75a1.136,1.136,0,0,1-1.125-1.143V802.41h9.049a10.233,10.233,0,0,0,3.615,3.2,1.67,1.67,0,0,0,1.677,0A10.173,10.173,0,0,0,242.657,802.41Zm-12.344,2.881a.572.572,0,0,0-.548-.6h-2.25a.572.572,0,0,0,0,1.143h2.25A.572.572,0,0,0,230.313,805.291Zm12.39-9.739v2.287c0,3.149-1.144,4.982-4.22,6.782a.56.56,0,0,1-.56,0c-3.076-1.8-4.22-3.638-4.22-6.782v-2.286a.57.57,0,0,1,.34-.525l3.937-1.714a.553.553,0,0,1,.444,0l3.938,1.714A.569.569,0,0,1,242.7,795.552Zm-2.46,1.274-.006-.005a.559.559,0,0,0-.785.094l-1.769,2.247-.7-1.064-.006-.01a.557.557,0,0,0-.774-.149.577.577,0,0,0-.156.792l1.125,1.714a.567.567,0,0,0,.444.254h.024a.565.565,0,0,0,.44-.214l2.25-2.857v0A.577.577,0,0,0,240.243,796.826Z",
    transform: "translate(-224.703 -793.268)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPaymentMethod);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_payment_method.0900e3e262d584fa736392106be2870c.svg";